$(document).ready(function () {
$(".short_description").click(function() {
  $('html, body').animate({
      scrollTop: $(".product-accordion-box").offset().top
  }, 900);
});
  
$('.testimonial-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
   arrows: false,
  centerMode: true,
                centerPadding: '0px',
        responsive: [
          {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        ]
    });

  $('.imgtext-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    adaptiveHeight: true,
   arrows: false 
    });


    $('.aboutinfo-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows: true 
    });


$(".product__info-container .ezrv-widget-container").click(function() {
    $('html,body').animate({                                                          
        scrollTop: $("#shopify-block-ARitCSnhsODYyck5tM__easyreviews_product_review_jmRg6X").offset().top - 80},
        'slow');
});
  
  
});


$('body').on('click', '.header_h4', function(e) {  
    $('.box-a1').find('.level-box').stop().slideUp();
    $(this).closest('.box-a1').find('.level-box').stop().slideToggle();
  $('.header_h4').not(this).removeClass('active');
  $(this).toggleClass('active');
});

$('body').on('click', '.awards-box', function(e) {  
  $('.awards-box').not(this).removeClass('active');
  $(this).toggleClass('active');
  $(this).addClass('active_box');
  $('.awards-wrapper h2').addClass('hide');
});
$('body').on('click', '.active_box', function(e) {  
  $('.awards-wrapper h2').removeClass('hide');
   $('.awards-box').removeClass('active_box');
});

